import { FLIPPED_ALIAS_KEYS } from "@babel/types";
import { View } from "binder"
import { BooleanType, ClassType, DateType, FloatType, IntegerType, IPropertyTypeVisitor, KnownClassType, ListType, PropertyType, ServerSideDataLoaderType, StringType, VoidType } from "../../structure";
import { DataModelBuilderViewModel, DataModelClass, Method, Property } from "../dataModelBuilder-viewModel";
import { MethodBodyCodeEditorViewModel } from "./methodBodyCodeEditor-viewModel"
import * as monaco from 'monaco-editor'
// declare var monaco : any;

export class MethodBodyCodeEditorView extends View<MethodBodyCodeEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-142BDA7C-690B-4C39-ACCC-C1CE58528DB6"
    }
    loadHtml(): string {
        let element = require('./methodBodyCodeEditor.html').default;
        let style = require('./methodBodyCodeEditor.less');
        return element;
    }
    constructor() {
        super();
        if(MethodBodyCodeEditorView._executionIndex==null){
            MethodBodyCodeEditorView._executionIndex=0;
        }
        MethodBodyCodeEditorView._executionIndex++;
        this.isRan = false;
        this.Rendered = false;
        this.hasData = false;
    }
    public static _executionIndex:number=0;
    public static currentModel:any;
    public set model(v: DataModelBuilderViewModel) { this._model = v; } public get model(): DataModelBuilderViewModel { return this._model;} private _model: DataModelBuilderViewModel;
    public set currentClass(v: DataModelClass) { this._currentClass = v; } public get currentClass(): DataModelClass { return this._currentClass;} private _currentClass: DataModelClass;
    public set currentMethod(v: Method) { this._currentMethod = v; } public get currentMethod(): Method { return this._currentMethod;} private _currentMethod: Method;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    
    confirm(){
        let code:string = this.editor?.getValue();
        let removeStart = code.split('//--Code Starts From Here--')[1];
        let removeEnd = removeStart.split('//--Code Ends Here--')[0];
        let result = removeEnd.trim();
        this.dataContext.confirm(result);
        this.editor?.dispose();
    }
    close(){
        this.editor?.dispose();
        this.dataContext.close();
    }

    public onRenderCompleted(): any {
        this.Rendered = true;
        this.Run();
    }
    public onDataContextSet():any{
        this.hasData = true;
        this.Run();
    }
    public Rendered:boolean;
    public hasData : boolean;
    public isRan:boolean;

    private getCodeForMethod(p:Method){
        let pre = '';
        let resolver = new typeNameResolver();
        let returnType = resolver.getName(p.returnType);
        if(p.isAsync){
            pre='async ';
            returnType=`Promise<${returnType}>`;
        }
        return `${pre}${p.name}(${p.arguments.map(x=>`${x.name}:${resolver.getName(x.type)}`)}):${returnType}{
\t\t//--Code Starts From Here--
\t\t${this.code}
\t\t//--Code Ends Here--
\t}`;
    }
    private editor;
    Run(){
        if(this.hasData==false)
            return;
        if(this.Rendered==false)
            return;
        if(this.isRan==true)
            return;
        this.isRan = true;
        setTimeout(()=>{
            let typeing = new typingGenerator().getTypings(this.model);
            let code = `class _TEST_ extends ${this.currentClass.name} {
\t${this.getCodeForMethod(this.currentMethod)}
}`
            monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
                noSemanticValidation: true,
                noSyntaxValidation: false
            });
    
            monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
                target: monaco.languages.typescript.ScriptTarget.ES5,
                allowNonTsExtensions: true
            });
            let libUri = `ts:filename/_methodbodycreator_${MethodBodyCodeEditorView._executionIndex}.d.ts`;
            if(MethodBodyCodeEditorView.currentModel!=null){
                MethodBodyCodeEditorView.currentModel.dispose();
            }
            monaco.languages.typescript.javascriptDefaults.addExtraLib(typeing, libUri);
            MethodBodyCodeEditorView.currentModel = monaco.editor.createModel(typeing, 'typescript', monaco.Uri.parse(libUri));
    
            let element2 = <HTMLElement>this.firstlevelElement.querySelector('#container');
            this.editor = monaco.editor.create(element2, {
                value: code,
                language: 'javascript'
            });
        },1)
    }
}

class typingGenerator{
    public getTypings(model:DataModelBuilderViewModel) : string{
        this.result = [];
        this.typeNameResolver = new typeNameResolver();
        this.result.push(`
declare class DataLoader{
    refresh():Promise<void>;
    refreshExport(type:string):Promise<void>;
}
declare class BaseType{
    OnLoad();
    StringIsNullOrEmpty(value:string):boolean;
    __GetClassName__():string;
    __CreatePaginationInfo(current:number,total:number):any;
    __CreateChildInstanceFromTypeName(typeName:string):any;
    __CreateComboBox(isMultiSelect:boolean,searchable:boolean,autorefresh:boolean=true):ViewModel;
    async __ShowPopup(viewModel:any,templateSelector:string,width?:string,height?:string):Promise<any>;
    async __CallServer(address:string,parameter:any):Promise<any>;
    async __PrintReport(reportId:string,data:any,copyCount:number);
    __ExportCsv(fileName:string,exportingData:any[]);
    __ConvertToPersianDate(d:moment.Moment,format?:string):string;

    closePopup(result?: any);

    async requestRefreshWindow();
    async messageBox(message:string,title:string,type:"success"|"warning"|"danger"|"dark",...buttons:{title:string,className:"danger"|"info"|"success"|"primary"|"secondary"|"warning",resultCode:string}[]):Promise<string>;
    async messageBoxDangerYesNo(message:string,title:string);
    async messageBoxWarningYesNo(message:string,title:string);
    async messageBoxSuccessYesNo(message:string,title:string);
    async messageBoxConfirmSuccess(message:string,title:string);
    async messageBoxConfirmWarning(message:string,title:string);
}
declare class ObservableArray<T> extends Array<T>{
    update(...children:T[]): any;
    insertAt(index:number,...items:T[]);
    clear();
    remove(...list: T[]): any;
}`)
        model.classes.forEach(x=>{
            this.createForClass(x);
        })
        return this.result.join('\r\n');
    } 
    private typeNameResolver : typeNameResolver;
    private result :string[];
    private createForClass(cls:DataModelClass){
        this.result.push(`declare class ${cls.name} extends BaseType{`);
        cls.properties.forEach(x=>this.createProperty(x));
        cls.methods.forEach(x=>this.createMethod(x));
        this.result.push("}");
    } 
    private createProperty(p : Property){
        this.result.push(`  ${p.name}:${this.typeNameResolver.getName(p.type)};`)
    }
    private createMethod(p : Method){
        let pre = '';
        let returnType = this.typeNameResolver.getName(p.returnType);
        if(p.isAsync){
            pre='async ';
            returnType=`Promise<${returnType}>`;
        }
        this.result.push(`  ${pre}${p.name}(${p.arguments.map(x=>`${x.name}:${this.typeNameResolver.getName(x.type)}`)}):${returnType}`)
    }
}

class typeNameResolver implements IPropertyTypeVisitor {
    getName(type:PropertyType):string{
        return type.Accept(this,null);
    }    

    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, parameter: any) {
        return 'DataLoader';
    }
    visitVoidType(arg0: VoidType, parameter: any) {
        return 'void';
    }
    visitBooleanType(arg0: BooleanType, parameter: any) {
        return 'boolean';
    }
    visitIntegerType(arg0: IntegerType, parameter: any) {
        return 'number';
    }
    visitFloatType(arg0: FloatType, parameter: any) {
        return 'number';
    }
    visitStringType(arg0: StringType, parameter: any) {
        return 'string';
    }
    visitListType(arg0: ListType, parameter: any) {
        return `ObservableArray<${this.getName(arg0.OfType)}>`;
    }
    visitClassType(arg0: ClassType, parameter: any) {
        return 'any';
    }
    visitKnownClassType(arg0: KnownClassType, parameter: any) {
        return arg0.ForClass.name;
    }
    visitDateType(arg0: DateType, parameter: any) {
        return "moment.Moment";
    }

}

